<template>
  <div class="integrations">
    <div
      v-for="(integration, index) in integrations"
      :key="index"
      class="integration"
      :class="`integration-${index + 1}`"
      :style="{ backgroundColor: '#FFFFFF' }"
    >
      <UiComponentImage
        :alt="integration.logo.alt"
        :expected-size="expectedSize"
        :height="integration.logo.height"
        :orientation="
          integration.logo.width > integration.logo.height
            ? 'portrait'
            : 'landscape'
        "
        :source="integration.logo.url"
        :width="integration.logo.width"
      />
    </div>
  </div>
</template>

<script setup>
// Composable
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  integrations: {
    required: true,
    type: Array,
  },
})

// Computed
const expectedSize = computed(() => {
  return screenWidth.value < 1328 ? 40 : 50
})
</script>

<style lang="postcss" scoped>
.integrations {
  @apply relative flex h-[318px] w-[375px];

  @screen md {
    @apply h-[204px] w-[720px];
  }

  @screen xl {
    @apply h-[278px] w-[840px];
  }

  .integration {
    @apply absolute flex justify-center items-center h-[90px] w-[90px] rounded-2xl;

    &.integration-1 {
      @apply -left-[45px] top-0;
    }

    &.integration-2 {
      @apply left-[69px] top-0;
    }

    &.integration-3 {
      @apply left-[183px] top-0;
    }

    &.integration-4 {
      @apply left-[297px] top-0;
    }

    &.integration-5 {
      @apply left-[29px] top-[114px];
    }

    &.integration-6 {
      @apply left-[143px] top-[114px];
    }

    &.integration-7 {
      @apply left-[257px] top-[114px];
    }

    &.integration-8 {
      @apply -left-3 top-[228px];
    }

    &.integration-9 {
      @apply left-[102px] top-[228px];
    }

    &.integration-10 {
      @apply left-[216px] top-[228px];
    }

    &.integration-11 {
      @apply left-[330px] top-[228px];
    }

    @screen md {
      &.integration-1 {
        @apply left-0 top-0 !important;
      }

      &.integration-2 {
        @apply left-[126px] top-0 !important;
      }

      &.integration-3 {
        @apply left-[252px] top-0 !important;
      }

      &.integration-4 {
        @apply left-[378px] top-0 !important;
      }

      &.integration-5 {
        @apply left-[504px] top-0 !important;
      }

      &.integration-6 {
        @apply left-[630px] top-0 !important;
      }

      &.integration-7 {
        @apply left-[63px] top-[126px] !important;
      }

      &.integration-8 {
        @apply left-[189px] top-[126px] !important;
      }

      &.integration-9 {
        @apply left-[315px] top-[126px] !important;
      }

      &.integration-10 {
        @apply left-[441px] top-[126px] !important;
      }

      &.integration-11 {
        @apply left-[567px] top-[126px] !important;
      }
    }

    @screen xl {
      @apply h-28 w-28 rounded-[26px];

      &.integration-1 {
        @apply left-0 top-0 !important;
      }

      &.integration-2 {
        @apply left-[145.6px] top-0 !important;
      }

      &.integration-3 {
        @apply left-[291.2px] top-0 !important;
      }

      &.integration-4 {
        @apply left-[436.8px] top-0 !important;
      }

      &.integration-5 {
        @apply left-[582.4px] top-0 !important;
      }

      &.integration-6 {
        @apply left-[728px] top-0 !important;
      }

      &.integration-7 {
        @apply left-[72px] top-[145.6px] !important;
      }

      &.integration-8 {
        @apply left-[217.6px] top-[145.6px] !important;
      }

      &.integration-9 {
        @apply left-[363.2px] top-[145.6px] !important;
      }

      &.integration-10 {
        @apply left-[508.8px] top-[145.6px] !important;
      }

      &.integration-11 {
        @apply left-[654.4px] top-[145.6px] !important;
      }
    }

    picture {
      @apply rounded-none;
    }
  }
}
</style>
